export type EducationalProgramStepFullLabelOptions = {
  preferShortProgramLabel?: boolean;
  preferShortProgramStepLabel?: boolean;
}

export const DEFAULT_STEP_FULL_LABEL_OPTIONS: EducationalProgramStepFullLabelOptions = {
  preferShortProgramLabel: true,
  preferShortProgramStepLabel: true,
};
